import styled from 'styled-components';
import Button from '../../Button/bundle.esm.js';

const ButtonStyled = styled(Button)`
  cursor: pointer;
  border: 1px solid #d4d4d4;
  z-index: 0;
  position: relative;

  &:not(:first-child) {
    margin-left: -1px;
  }

  &.Button--active {
    border: 1px solid #000;
    z-index: 1;
  }

  .Button {
  }
`;

export { ButtonStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
